import { styled } from '@mui/material';
import { withDatagridStickyStyles } from 'shared/react-admin/Datagrids/DatagridSticky/withDatagridStickyStyles';
import { DatagridWithStickyActions } from 'shared/react-admin/Datagrids/DatagridWithStickyActions/DatagridWithStickyActions';
import { getColumnStyle } from 'utils';

const shrinkColumnStyle = { width: 0 };

const StickyDatagridWithStickyActions = withDatagridStickyStyles(DatagridWithStickyActions);

export const DatagridStyled = styled(StickyDatagridWithStickyActions)({
  '& .column-gateway': shrinkColumnStyle,
  '& .column-currency': shrinkColumnStyle,
  '& .column-paymentMin': getColumnStyle(115),
  '& .column-paymentMax': getColumnStyle(120),
  '& .column-payoutMin': getColumnStyle(115),
  '& .column-payoutMax': getColumnStyle(120),
  '& .column-createdAt': getColumnStyle(115),
  '& .column-updatedAt': getColumnStyle(115),
});
